'use client';

export { default } from './InputBase';
export { default as inputBaseClasses } from './inputBaseClasses';
export * from './inputBaseClasses';